<template>
  <v-card
    :class="className"
    color="white"
    class="app-form-buttons"
    flat
  >
    <v-flex
      :id="customModalLayout"
      class="back-btn"
    >
      <div>
        <v-btn
          v-if="!noBackButton"
          @click="back"
          color="secondary"
        >
          {{ backButtonText }}
        </v-btn>
      </div>

      <div class="buttons-right">
        <v-btn
          id="btn-clean"
          v-if="!noClear"
          :disabled="disabled"
          @click="clear"
          color="secondary"
          class="white--text"
        >
          Limpar
        </v-btn>

        <v-btn
          v-if="cancelButton"
          @click="cancel"
          color="light-gray"
        >
          Cancelar
        </v-btn>

        <v-btn
          id="btn-save"
          v-if="!noSave"
          :disabled="disabled"
          @click="save"
          color="primary"
          class="white--text"
        >
          {{ saveText }}
        </v-btn>
        <v-btn
          id="btn-save-new"
          v-if="!onlySave && !noSave"
          @click="saveAndNew"
          color="primary"
          class="white--text"
        >
          Salvar e Novo
        </v-btn>
      </div>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'AppFormButtons',
  props: {
    v: {
      type: Object,
      default: undefined
    },
    onlySave: {
      type: Boolean,
      default: () => false
    },
    noClear: {
      type: Boolean,
      default: () => false
    },
    noSave: {
      type: Boolean,
      default: () => false
    },
    saveText: {
      type: String,
      default: () => 'Salvar'
    },
    noBackButton: {
      type: Boolean,
      default: () => false
    },
    noEnterPress: {
      type: Boolean,
      default: () => false
    },
    className: {
      type: String,
      default: () => 'mt-3'
    },
    cancelButton: {
      type: Boolean,
      default: () => false
    },
    backButtonText: {
      type: String,
      default: () => 'Voltar'
    },
    backButtonRedLayout: {
      type: Boolean,
      default: () => false
    },
    customModalLayout: {
      type: String,
      default: () => ''
    },
    disabled: Boolean,
    isModal: Boolean
  },
  methods: {
    back() {
      if (this.isModal) return this.cancel()

      this.$router.go(-1)
    },
    cancel() {
      this.v.$reset()
      this.$emit('cancel')
    },
    clear() {
      this.v.$reset()
      this.$emit('clear')
    },
    save($event) {
      if (this.noEnterPress && $event.x === 0 && $event.y === 0) {
        return
      }
      this.v.$touch()
      this.$emit('vTouch')
      if (!this.v.$invalid) {
        this.$emit('save')
      } else {
        this.$nextTick(() => this.$emit('validationError', this.v))
      }
    },
    saveAndNew() {
      this.v.$touch()
      if (!this.v.$invalid) {
        this.$emit('saveAndNew')
        this.v.$reset()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.back-btn {
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

.buttons-right {
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

#updateProfileModalCustom {
  justify-content: center;
}
</style>
